<template>
  <section class="page-intro">
    <h2 class="heading-2" v-html="heading"></h2>
    <div  v-if="body.length > 0">
      <div class="intro" v-html="body"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageIntro',

  props: {
    heading: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-intro {
    margin: 0 auto 0px;
    padding: 0 20px;
    max-width: 810px;
  }

  .intro {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    p {
      color: #231F20;
      font-size: 18px;
      line-height: 30px;
    }
  }
</style>
